/* ============================================================
   HygieneHub - content-page motion engine (.hh-page)
   Scroll reveals + stagger, count-up stats, crafted FAQ
   accordion with live search & category filters. Safe to run
   multiple times (Shopify section reloads in the editor).
   ============================================================ */
(function () {
  var W = window;

  function each(list, fn) { Array.prototype.forEach.call(list, fn); }

  // ---- scroll reveal + auto stagger ----
  function initReveal(root) {
    // auto-stagger: children of [data-stagger] get an incremental delay
    each(root.querySelectorAll('.hh-page [data-stagger]'), function (wrap) {
      if (wrap._hhStag) return; wrap._hhStag = 1;
      var step = parseFloat(wrap.getAttribute('data-stagger')) || 0.08;
      each(wrap.querySelectorAll(':scope > .fx, :scope > .fx-scale'), function (el, i) {
        el.style.setProperty('--d', (i * step).toFixed(3) + 's');
      });
    });
    var targets = root.querySelectorAll('.hh-page .fx:not(.in), .hh-page .fx-scale:not(.in)');
    // These start at opacity:0, so if the observer never runs the content is
    // invisible, not just un-animated. Always fail open.
    if (!('IntersectionObserver' in W)) { each(targets, function (el) { el.classList.add('no-anim', 'in'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); } });
    }, {
      threshold: 0,
      // Positive bottom margin expands the root DOWNWARD, so an element starts
      // fading a screen-height BEFORE it scrolls into view and has finished by
      // the time it is seen. The old -6% did the opposite: it delayed the
      // trigger until the element was already on screen, which read as a jolt.
      rootMargin: '0px 0px 700px 0px'
    });
    var vh = W.innerHeight || document.documentElement.clientHeight;
    var deferred = [];
    each(targets, function (el) {
      // Already on screen at load: show it instantly, no transition, so the
      // user never watches the top of the page assemble itself.
      if (el.getBoundingClientRect().top < vh) { el.classList.add('no-anim', 'in'); }
      else { deferred.push(el); io.observe(el); }
    });
    // Fail open. After a couple of seconds everything still waiting is shown
    // outright, no transition. Content must never be stuck at opacity:0 because
    // an observer didn't fire, and by then the reader is well past the point
    // where an entrance animation is doing any work anyway.
    W.setTimeout(function () {
      each(deferred, function (el) {
        if (!el.classList.contains('in')) { el.classList.add('no-anim', 'in'); io.unobserve(el); }
      });
    }, 2000);
  }

  // ---- social clip rails: only fetch and play what is actually on screen ----
  // Videos ship as preload="none" + poster, so the page costs 8 thumbnails
  // instead of 8 video streams. Mirrors the homepage rail behaviour.
  function initClips(root) {
    var vids = root.querySelectorAll('.hh-page video[data-lazy-clip]');
    if (!vids.length) return;
    var reduce = W.matchMedia && W.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (!('IntersectionObserver' in W)) return; // posters still show; no autoplay
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        var v = e.target;
        if (e.isIntersecting) {
          if (!v.dataset.loaded) { v.preload = 'auto'; v.load(); v.dataset.loaded = '1'; }
          if (!reduce) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
        } else if (!v.paused) { v.pause(); }
      });
    }, { threshold: 0.4 });
    each(vids, function (v) { io.observe(v); });
  }

  // ---- count-up numbers: <span data-count="2000000" data-suffix="+"> ----
  function initCounts(root) {
    var els = root.querySelectorAll('.hh-page [data-count]');
    if (!els.length) return;
    var fmt = function (n) { return Math.round(n).toLocaleString('en-US'); };
    var run = function (el) {
      if (el._hhRun) return; el._hhRun = 1;
      var end = parseFloat(el.getAttribute('data-count')) || 0;
      var suffix = el.getAttribute('data-suffix') || '';
      var prefix = el.getAttribute('data-prefix') || '';
      var dur = 1400, t0 = null;
      var tick = function (t) {
        if (t0 === null) t0 = t;
        var p = Math.min((t - t0) / dur, 1);
        var eased = 1 - Math.pow(1 - p, 3);
        el.textContent = prefix + fmt(end * eased) + suffix;
        if (p < 1) requestAnimationFrame(tick);
      };
      requestAnimationFrame(tick);
    };
    if (!('IntersectionObserver' in W)) { each(els, run); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { run(e.target); io.unobserve(e.target); } });
    }, { threshold: 0.5 });
    each(els, function (el) { io.observe(el); });
  }

  // ---- FAQ accordion + search + filters ----
  function initFaq(root) {
    each(root.querySelectorAll('.hh-faq .faq-list'), function (list) {
      if (list._hhFaq) return; list._hhFaq = 1;
      var page = list.closest('.hh-faq');
      var items = list.querySelectorAll('.faq-q');
      var search = page.querySelector('#faqSearch');
      var chips = page.querySelectorAll('.chip');
      var countEl = page.querySelector('.faq-count');
      var emptyEl = page.querySelector('.faq-empty');
      var activeCat = 'all';

      // accordion toggle
      each(items, function (item) {
        var head = item.querySelector('.faq-head');
        var body = item.querySelector('.faq-body');
        head.addEventListener('click', function () {
          var open = item.classList.toggle('open');
          head.setAttribute('aria-expanded', open ? 'true' : 'false');
          body.style.maxHeight = open ? body.scrollHeight + 'px' : '0px';
        });
      });
      W.addEventListener('resize', function () {
        each(list.querySelectorAll('.faq-q.open .faq-body'), function (b) { b.style.maxHeight = b.scrollHeight + 'px'; });
      });

      // filter logic
      function apply() {
        var q = (search && search.value ? search.value : '').trim().toLowerCase();
        var shown = 0;
        each(items, function (item) {
          var cat = item.getAttribute('data-cat') || '';
          var text = (item.textContent || '').toLowerCase();
          var ok = (activeCat === 'all' || cat === activeCat) && (q === '' || text.indexOf(q) !== -1);
          item.classList.toggle('hide', !ok);
          if (ok) shown++;
        });
        if (countEl) countEl.textContent = shown + (shown === 1 ? ' answer' : ' answers');
        if (emptyEl) emptyEl.hidden = shown !== 0;
      }
      if (search) search.addEventListener('input', apply);
      each(chips, function (chip) {
        chip.addEventListener('click', function () {
          activeCat = chip.getAttribute('data-cat') || 'all';
          each(chips, function (c) { c.classList.toggle('active', c === chip); });
          apply();
        });
      });
      apply();
    });
  }

  // ---- About page: scroll-driven journey line ----
  // A bead is pinned at the vertical centre of the viewport and slides
  // horizontally along a curving track that weaves around the value blocks.
  // The track fills in behind the bead and each station node lights up as it
  // passes. Pure inline SVG + rAF-throttled scroll, no dependencies.
  function initJourney(root) {
    var wrap = root.querySelector('.hh-about .values');
    if (!wrap || wrap._hhJourney) return; wrap._hhJourney = 1;
    var svg = wrap.querySelector('.journey');
    var track = svg && svg.querySelector('.track');
    var trail = svg && svg.querySelector('.trail');
    var bead = wrap.querySelector('.journey-bead');
    if (!svg || !track || !trail) return;
    var reduce = W.matchMedia && W.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var SVGNS = 'http://www.w3.org/2000/svg';
    var total = 0, nodes = [];

    function catmull(p) {
      if (p.length < 2) return '';
      var d = 'M' + p[0].x + ' ' + p[0].y;
      for (var i = 0; i < p.length - 1; i++) {
        var p0 = p[i - 1] || p[i], p1 = p[i], p2 = p[i + 1], p3 = p[i + 2] || p2;
        var c1x = p1.x + (p2.x - p0.x) / 6, c1y = p1.y + (p2.y - p0.y) / 6;
        var c2x = p2.x - (p3.x - p1.x) / 6, c2y = p2.y - (p3.y - p1.y) / 6;
        d += 'C' + c1x + ' ' + c1y + ' ' + c2x + ' ' + c2y + ' ' + p2.x + ' ' + p2.y;
      }
      return d;
    }
    // length along the track whose point sits at container-y === y (track is
    // strictly top-to-bottom, so a binary search converges cleanly)
    function lenAtY(y) {
      var lo = 0, hi = total, mid, pt;
      for (var i = 0; i < 20; i++) { mid = (lo + hi) / 2; pt = track.getPointAtLength(mid); if (pt.y < y) lo = mid; else hi = mid; }
      return (lo + hi) / 2;
    }

    function build() {
      var w = wrap.clientWidth, h = wrap.clientHeight;
      if (!w || !h) return;
      var mobile = w < 750;
      var leftX = w * 0.13, rightX = w * 0.87, midX = w * 0.5;
      var rows = wrap.querySelectorAll('.value-row');
      var stations = [];
      each(rows, function (r, i) {
        var cy = r.offsetTop + r.offsetHeight / 2;
        var x = mobile ? (i % 2 === 0 ? rightX : leftX) : midX;
        stations.push({ x: x, y: cy });
      });
      if (!stations.length) return;
      var pts = [{ x: stations[0].x, y: 0 }];
      stations.forEach(function (s) { pts.push(s); });
      pts.push({ x: stations[stations.length - 1].x, y: h });
      var d = catmull(pts);
      svg.setAttribute('viewBox', '0 0 ' + w + ' ' + h);
      svg.setAttribute('width', w); svg.setAttribute('height', h);
      track.setAttribute('d', d); trail.setAttribute('d', d);
      total = track.getTotalLength();
      trail.style.strokeDasharray = total;
      trail.style.strokeDashoffset = reduce ? 0 : total;
      each(svg.querySelectorAll('.node'), function (n) { n.parentNode.removeChild(n); });
      nodes = stations.map(function (s) {
        var c = document.createElementNS(SVGNS, 'circle');
        c.setAttribute('class', 'node'); c.setAttribute('cx', s.x); c.setAttribute('cy', s.y); c.setAttribute('r', mobile ? 6 : 7);
        c._len = lenAtY(s.y);
        svg.appendChild(c);
        return c;
      });
      update();
    }

    function update() {
      if (!total) return;
      var rect = wrap.getBoundingClientRect();
      var vc = W.innerHeight / 2;
      var targetY = vc - rect.top;
      var prog = targetY / rect.height;
      if (reduce) {
        nodes.forEach(function (n) { n.classList.add('lit'); });
        return;
      }
      var ty = Math.max(0, Math.min(rect.height, targetY));
      var len = lenAtY(ty);
      trail.style.strokeDashoffset = Math.max(0, total - len);
      var pt = track.getPointAtLength(len);
      if (bead) {
        bead.style.top = vc + 'px';
        bead.style.left = (rect.left + pt.x) + 'px';
        bead.style.opacity = (prog > 0.015 && prog < 0.985) ? '1' : '0';
      }
      nodes.forEach(function (n) { n.classList.toggle('lit', n._len <= len + 0.5); });
    }

    var ticking = false;
    function onScroll() { if (!ticking) { ticking = true; requestAnimationFrame(function () { update(); ticking = false; }); } }
    W.addEventListener('scroll', onScroll, { passive: true });
    W.addEventListener('resize', build);
    W.addEventListener('load', build);
    build();
  }

  function initAll(root) {
    root = root || document;
    if (!root.querySelector('.hh-page')) return;
    initReveal(root);
    initClips(root);
    initCounts(root);
    initFaq(root);
    initJourney(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }
  // Shopify theme editor: re-init when a section reloads
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target || document); });
})();
